import React from 'react';
import MailIcon from '@narvar/nth-mail-icon';
import PropTypes from 'prop-types';

const CarrierLogo = ({ carrier, defaultLogo: DefaultLogo }) => {
  const [usePlaceholder, setUsePlaceholder] = React.useState(false);

  if (usePlaceholder) return DefaultLogo ? <DefaultLogo /> : <MailIcon s={{ width: '5rem' }} />;

  return (
    <img
      src={`/r2/img/carriers/${carrier}.svg`}
      style={{
        maxHeight: '8rem',
        width: '8rem',
      }}
      alt={`${carrier}`}
      onError={() => setUsePlaceholder(true)}
    />
  );
};

CarrierLogo.defaultProps = {
  carrier: '',
  defaultLogo: undefined,
};

CarrierLogo.propTypes = {
  carrier: PropTypes.string,
  defaultLogo: PropTypes.func,
};

export default CarrierLogo;
